import {
	KnownProfileDataResponses,
} from "@/components/User/types/profile";

import API from "@/services/api";

export enum Endpoints {
	ProfileData = "/users/",
}

const getProfileData = () => {

	// Returns one of the Known Profile Data Responses
	return new Promise<KnownProfileDataResponses>(async (resolve, reject) => {

		// Indicates all Known Profile Data Responses
		API.get<KnownProfileDataResponses>({
			endpoint: Endpoints.ProfileData,
			versions: [2]
		})
		.then(res => {
			resolve(res.promise.data);
		})
		.catch(err => {
			reject(err);
		})
	})
}

export default {
	getProfileData
};
